"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DetailsRow_base_1 = require("./DetailsRow.base");
var DetailsRow_styles_1 = require("./DetailsRow.styles");
exports.DetailsRow = Utilities_1.styled(DetailsRow_base_1.DetailsRowBase, DetailsRow_styles_1.getStyles, undefined, {
    scope: 'DetailsRow'
});
//# sourceMappingURL=DetailsRow.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DetailsList/DetailsRow.js
// module id = 908
// module chunks = 0